import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Tile from '~/components/Tile'
import { PageHeader } from '~/components/PageHeader'
import StakedInfo from '~/components/StakedInfo'
import { useEarn } from '~/lib/useEarns'
import { toAmount, toBigNumber } from '~/lib/helpers'
import StakeSelector from '~/components/StakeSelector'
import { pathToEarnPage } from '~/lib/routes'
import Typography from '~/components/Typography'
import Navigation from '~/components/Navigation'
import { CONFIG } from '~/lib/config'
import { EarnStatus } from '~/contracts/useEarnContract'
import { SwitchNetworkButton } from '~/components/SwitchNetworkButton'

import style from './ClaimPage.pcss'

const ClaimPage: FC = () => {
	const { contract, earnType } = useEarn()
	const [pending, setPending] = useState(false)
	const navigate = useNavigate()

	const isSuccess = contract?.status === EarnStatus.SUCCESS

	const amount = isSuccess
		? toAmount(contract.token?.decimals, contract.earn.pendingReward)
		: ''

	const onSubmit = () => {
		setPending(true)
		contract
			.deposit(toBigNumber(contract.token.decimals, '0'))
			.catch(console.error)
			.finally(() => {
				contract.refresh()
				setPending(false)
			})
	}

	let disabled
	let buttonText
	if (!isSuccess) {
		disabled = true
		buttonText = 'Loading...'
	} else if (pending) {
		disabled = true
		buttonText = 'Claiming...'
	} else {
		disabled = Number(amount) <= 0
		buttonText = `Claim ${amount} SIS`
	}

	const value = isSuccess
		? contract.priceOf(contract.earn.pendingReward).toFixed(2)
		: ''

	return (
		<Tile>
			<Tile.Header>
				<PageHeader title="Farming" />
				<Navigation />
			</Tile.Header>

			<Tile.Item disabled={pending} className={style.inner}>
				<StakeSelector
					onAmountChange={() => {}}
					onDexChange={(earnType) =>
						navigate(pathToEarnPage(earnType, 'claim'))
					}
					readOnly
					earnType={earnType}
					amount={amount}
					maxAmount="0"
				/>
				<Typography tag="p" color="gray">
					Value: $
					<Typography color="inherit">{value || '{??}'}</Typography>
				</Typography>
			</Tile.Item>

			<Tile.Item>
				<StakedInfo />
			</Tile.Item>

			<Tile.Footer>
				<SwitchNetworkButton
					block
					color="black"
					requiredChainId={CONFIG.earns[earnType].chainId}
					disabled={disabled}
					onClick={onSubmit}
				>
					{buttonText}
				</SwitchNetworkButton>
			</Tile.Footer>
		</Tile>
	)
}

export default ClaimPage
